<template>
    <div class='wrap'>
        <div id="updatedAvatar">
            <div class="updatedHead">
                头像上传<s @click="closeAvatar"></s>
            </div>
            <div class="updatedContent">
                <div class="updatedLeft">
                    <div id="upImg" @mousedown="moveImg($event)" :style="{backgroundSize:scale*240+'px'}"></div>

                    <div class="photoFrame">
                        <span @click="reduce" class="reduce"><span></span></span>
                        <span class="slide-big">
                            <i class="slide-sm" id="slide" @mousedown="scaleBar($event)" :style="{left:(scale-1)*47+'px'}"></i>
                        </span>
                        <span @click="increase" class="increase"></span>
                    </div>
                </div>
                <div class="updatedRight">
                    <p>头像预览</p>
                    <div id="sm_pic" :style="{backgroundSize:scale*120+'px'}"></div>
                </div>
            </div>
            <div class="upText">
                <span class="file"><input id="doc" ref="img" type="file" accept="image/*" @change="changeSuccess($event)">选择图片</span><span
                class="format">支持JPG、JPEG、PNG,小于2M</span>
            </div>
            <div class="bottom-group">
                <span class="bottom-btn1" @click="closeAvatar">取消</span>
                <span class="bottom-btn2" @click="updatedSuccess">保存</span>
            </div>
        </div>
    </div>
</template>


<script type="text/ecmascript-6">
    export default {
        props:["img"],
        data() {
            return {
                scale: 1,
                avatarInfo: {},
                startx: 0,
                starty: 0,
                barX: 0,

                truely_width:"",
            }
        },
        methods:{
            closeAvatar() {
                this.$parent.openAvatar = false;
                // this.returnImg()
                this.clearImg();
            },
            reduce: function () {
                if (this.scale >= 1.5) {
                    this.scale -= 0.5;
                }else {
                    this.scale=1;
                }
            },
            increase: function () {
                if (this.scale <= 4.5) {
                    this.scale += 0.5;
                }else {
                    this.scale=5;
                }
            },

            updatedSuccess() {   //保存
                if(!this.avatarInfo.avatar){
                    this.errorTip("尚未选择图片")
                    return;
                }

                this.$parent.openAvatar = false;
                let rate = this.truely_width/(this.scale * 240);   //比例

                var myUpdated=new FormData();
                myUpdated.append("x",-this.startx*rate);
                myUpdated.append("y",-this.starty*rate);
                myUpdated.append("w",240*rate);
                myUpdated.append('avatar',this.avatarInfo.avatar);
                //console.log(myUpdated)
                this.$http.post('api/user/avatar',myUpdated,{transformRequest: [function (data) {
                    return data;
                }]}).then( res => {
                    if(res.status == 200){
                        this.$func.getUserInfo(true);
                        this.clearImg();
                    }
                })
            },

            changeSuccess(event) {  //选择图片
                var docObj = document.getElementById("doc");

                if (docObj.files && docObj.files[0]) {
                    let img_file = docObj.files[0];
                    let size = img_file.size/1024;
                    if(size > 2000){ //2M
                        this.errorTip("上传图片大小不能大于2M")
                        return;
                    }

                    var imgObjPreview = document.getElementById("upImg");
                    var sm_pic=document.getElementById("sm_pic");
                    //console.log(docObj.files[0])
                    //this.$store.state.userInfo.userInfo.user_logo = window.URL.createObjectURL(docObj.files[0]);
                    let src = window.URL.createObjectURL(docObj.files[0]);

                    imgObjPreview.style.backgroundImage = `url(${src})`;
                    sm_pic.style.backgroundImage = `url(${src})`;
                    this.avatarInfo.avatar = docObj.files[0];
                    
                    let image = new Image();
                    image.src = src;
                    image.onload = ()=>{
                        this.truely_width = image.width;
                    }
                    
                }

                docObj.value = "";
            },
            moveImg: function (event) {
                var onOff = false;
                var event = event || window.event;
                var startX = Number(this.startx);
                var startY = Number(this.starty);
                var that = this;
                var upImg = document.getElementById("upImg");
                var sm_pic = document.getElementById("sm_pic");
                var x = event.pageX;
                var y = event.pageY;
                var moveX = 0;
                var moveY = 0;
                event.preventDefault();

                document.onmousemove = function (event) {
                    onOff = true;
                    moveX = event.pageX;  //最新的鼠标坐标
                    moveY = event.pageY;  

                    upImg.style.backgroundPosition = (startX + moveX - x) + "px " + (startY + moveY - y) + "px";
                    sm_pic.style.backgroundPosition = (startX + moveX - x) / 2 + "px " + (startY + moveY - y) / 2 + "px";
                };

                document.onmouseup = function (event) {
                    if (onOff) {
                        startX += moveX - x;
                        startY += moveY - y;
                        that.startx = startX;
                        that.starty = startY;
                    }
                    document.onmousemove = null;
                    document.onmouseup = null;
                };

            },

            scaleBar(event) {
                var onOff = false;
                var event = event || window.event;
                var startX = Number((this.scale-1)*47);
                var that = this;
                var slide = document.getElementById("slide");
                var x = event.pageX;
                var moveX = 0;
                event.preventDefault();

                document.onmousemove = function (event) {
                    onOff = true;
                    moveX = event.pageX;
                    var long = moveX - x + startX;
                    if (long >= 0 && long < 188) {
                        slide.style.left = long + "px";
                        that.scale = slide.offsetLeft / 188 * 4 + 1;
                        console.log(that.scale)
                    }
                };

                document.onmouseup = function () {
                    if (onOff) {
                        startX += moveX - x;
                        that.barX = startX;
                    }
                    document.onmousemove = null;
                    document.onmouseup = null;
                };

            },
            clearImg(){
                var imgObjPreview = document.getElementById("upImg");
                var sm_pic = document.getElementById("sm_pic");

                imgObjPreview.style.backgroundImage = ``;
                sm_pic.style.backgroundImage = ``;
                this.avatarInfo.avatar = ""
            },
            // returnImg:function() {
            //     var imgObjPreview = document.getElementById("upImg");
            //     var sm_pic=document.getElementById("sm_pic");
            // }
        },
        // mounted() {
        //     this.returnImg();
        // },
        beforeDestroy() {
            this.maskOpen=false;
        }

    }
</script>


<style lang="less" rel="stylesheet/less" scoped>
    .wrap{
        position: fixed;
        height: 100%;
        width:100%;
        z-index:5;
        background: rgba(255,255,255,0.7);
        left: 0;
        top:0;
    }


    #updatedAvatar {
        position: absolute;
        left:50%;
        top:50%;
        margin-left: -251px;
        margin-top: -194px;
        width: 502px;
        height: 387px;
        background-color: #fff;
        z-index: 150;
        box-shadow: 0px 13px 16px 0px rgba(0, 0, 0, 0.30);
        .updatedHead {
            font-size: 14px;
            color: #808080;
            height: 24px;
            line-height: 14px;
            padding: 12px 0 0 15px;
            border-bottom: 1px solid #d8d8d8;
            s {
                position: absolute;
                top: 5px;
                right: 8px;
                width: 24px;
                height: 24px;
                background: url(~src/assets/image/bigX.png) no-repeat;
                cursor: pointer;
            }
        }
        .updatedContent {
            .updatedLeft {
                width: 240px;
                height: 272px;
                position: absolute;
                left: 45px;
                top: 61px;

                #upImg {

                    height: 240px;
                    width:240px;
                    background-size: contain;
                    background-color: rgba(128, 128, 128, 0.5);
                    overflow: hidden;
                    background-repeat: no-repeat;
                    cursor: move;
                }


                .photoFrame {
                    height: 15px;
                    margin-top: 17px;
                    .reduce {
                        height:14px;
                        width:14px;
                        display: inline-block;
                        cursor: pointer;
                        span {
                            display: inline-block;
                            width:14px;
                            height:3px;
                            background-color: #cdcdcd;
                            margin-bottom: 6px;
                        }
                    }
                    .slide-big {
                        position: relative;
                        display: inline-block;
                        width: 202px;
                        height: 3px;
                        background-color: #cdcdcd;
                        margin-bottom: 6px;
                        .slide-sm {
                            position: absolute;
                            top: -5px;
                            left: 50%;
                            background: url(~src/assets/image/around.png) no-repeat;
                            width: 14px;
                            height: 14px;
                            border-radius: 7px;
                            cursor: pointer;
                        }
                    }
                    .increase {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background: url(~src/assets/image/cross_light.png) no-repeat;
                        cursor: pointer;
                    }
                }
            }
            .updatedRight {
                position: absolute;
                right: 39px;
                top: 61px;
                width: 120px;
                &>p {
                    height: 14px;
                    line-height: 14px;
                    font-size: 14px;
                    color: #828282;
                    letter-spacing: 0.55px;
                    text-align: center;
                    margin-bottom: 33px;
                }
                &>div {
                    display: block;
                    height: 120px;
                    border-radius: 64px;
                    background-size: contain;
                    background-repeat: no-repeat;
                }
            }
        }
        .upText  {
            position:absolute;
            left:37px;
            bottom:23px;
            .file {
                position: relative;
                display: inline-block;
                padding-left: 20px;
                padding-right: 10px;
                line-height: 14px;
                font-size: 14px;
                overflow: hidden;
                color: #4990E2;
                vertical-align: middle;

                background: url("~src/assets/image/cross_deep.png") no-repeat;
                input {
                    position: absolute;
                    font-size: 100px;
                    right: 0;
                    top: 0;
                    opacity: 0;
                }
            }
            &> span.format {
                font-size: 10px;
                color: #808080;
                letter-spacing: 0.39px;
            }
        }
        .bottom-group {
            position: absolute;
            right: 29px;
            bottom: 21px;
            height: 25px;
            font-size: 0;
            &>span {
                margin-left: 20px;
                display: inline-block;
                background: #01b6ad;
                border-radius: 2px;
                width: 64px;
                height: 25px;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 0.55px;
                text-align: center;
                line-height: 25px;
                cursor: pointer;
            }
            
        }
    }

</style>


// WEBPACK FOOTER //
// upAvatar.vue?1b45a1d3